import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { computerScienceData } from '../../data/departmentalData/computerScience';

const ComputerScience = () => {
  return <TemplatePage data={computerScienceData} />;
};

export default ComputerScience;
